// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reportDetails__kYw_z {
  padding: 15px 25px 25px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 20px;
}
@media (max-width: 850px) {
  .reportDetails__kYw_z {
    padding: 15px;
    gap: 15px;
  }
}

.reportNotificationWrpr__aH56B {
  height: 21px;
}

.reportNotification__EYCWt {
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--labels-outline-stroke-text-success);
  display: inline-block;
  padding: 4px 9px;
  border: 1px solid var(--labels-outline-stroke-text-success);
  border-radius: 2px;
}

.extraInfo__aO_Qq {
  font-size: 12px;
  line-height: 20px;
  color: var(--inputs-filled-text);
  padding: 9px 20px;
  width: 100%;
  border: 1px solid var(--tables-primary-row-stroke, );
  background: var(--tabs-surface-active);
  border-radius: 5px;
}

.twoPartsWrpr__vzL4A {
  width: 100%;
  padding: 0 25px;
  display: grid;
  grid-template-columns: 3fr 2fr;
  align-items: flex-start;
  gap: 15px;
}

.textareasBlock__vHWjw {
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}

.hideBlock__RFW02 {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/ReportDetails/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,SAAA;AAzEF;AA2EE;EAPF;IAQI,aAAA;IACA,SAAA;EAxEF;AACF;;AA2EA;EACE,YAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gDAAA;EACA,qBAAA;EACA,gBAAA;EACA,2DAAA;EACA,kBAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,iBAAA;EACA,WAAA;EACA,oDAAA;EACA,sCAAA;EACA,kBAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAxEF;;AA2EA;EACE,aAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.reportDetails {\n  padding: 15px 25px 25px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  gap: 20px;\n\n  @media (max-width: 850px) {\n    padding: 15px;\n    gap: 15px;\n  }\n}\n\n.reportNotificationWrpr {\n  height: 21px;\n}\n\n.reportNotification {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n  text-transform: uppercase;\n  color: var(--labels-outline-stroke-text-success);  \n  display: inline-block;\n  padding: 4px 9px;\n  border: 1px solid var(--labels-outline-stroke-text-success);\n  border-radius: 2px;\n}\n\n.extraInfo {\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--inputs-filled-text);\n  padding: 9px 20px;\n  width: 100%;\n  border: 1px solid var(--tables-primary-row-stroke,);\n  background: var(--tabs-surface-active);\n  border-radius: 5px;\n}\n\n.twoPartsWrpr {\n  width: 100%;\n  padding: 0 25px;\n  display: grid;\n  grid-template-columns: 3fr 2fr;\n  align-items: flex-start;\n  gap: 15px;\n}\n\n.textareasBlock {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  row-gap: 15px;\n}\n\n.hideBlock {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reportDetails": `reportDetails__kYw_z`,
	"reportNotificationWrpr": `reportNotificationWrpr__aH56B`,
	"reportNotification": `reportNotification__EYCWt`,
	"extraInfo": `extraInfo__aO_Qq`,
	"twoPartsWrpr": `twoPartsWrpr__vzL4A`,
	"textareasBlock": `textareasBlock__vHWjw`,
	"hideBlock": `hideBlock__RFW02`
};
module.exports = ___CSS_LOADER_EXPORT___;
